<div class="hid-dialog">
  <div class="hid-header">
    <h2 class="hid-title">Hygiene Image Details</h2>
    <button type="button" class="hid-close" (click)="close()" aria-label="Close">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div class="hid-body">
    <!-- Left: Image -->
    <div class="hid-image-col">
      <div class="hid-image-wrap">
        <img *ngIf="picture.fileName" [src]="picture.fileName" [alt]="picture.departmentName" class="hid-img">
        <div *ngIf="!picture.fileName" class="hid-img-placeholder">
          <i class="fa fa-image"></i>
        </div>
      </div>
      <div class="hid-location" *ngIf="campusName || buildingName">
        <span *ngIf="campusName" class="hid-location-item"><strong>Campus:</strong> {{ campusName }}</span>
        <span *ngIf="buildingName" class="hid-location-item"><strong>Building:</strong> {{ buildingName }}</span>
      </div>
    </div>
    <!-- Right: Staff details (list scrollable) -->
    <div class="hid-staff-section">
      <h3 class="hid-staff-heading">Staff Details</h3>
      <div class="hid-caption">
        <span class="hid-dept">{{ picture.departmentName }}</span>
        <span class="hid-meta">{{ formatHygieneTime(picture.hygieneDate) }} · {{ picture.employeeCount }} staff</span>
      </div>
      <div class="hid-staff-scroll">
        <ul *ngIf="staffList.length" class="hid-staff-list">
          <li *ngFor="let s of staffList" class="hid-staff-item">
            <span class="hid-staff-name">{{ s.staffName ?? '—' }}</span>
            <span class="hid-staff-aadhar">Aadhar: {{ s.aadharNo ?? '—' }}</span>
          </li>
        </ul>
        <p *ngIf="staffList.length === 0" class="hid-empty">No staff details in this record.</p>
      </div>
    </div>
  </div>
</div>
